import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FaShieldAlt, FaLock, FaCheck } from 'react-icons/fa';

const FooterPrivacyNote = () => {
  return (
    <footer className="mt-12 font-arial">
      <div className="bg-gray-50 border-2 border-gray-200 p-6">
        <div className="flex items-center space-x-3 mb-6 border-b-2 border-gray-200 pb-4">
          <div className="w-10 h-10 bg-black flex items-center justify-center">
            <SafeIcon icon={FaShieldAlt} className="w-5 h-5 text-white" />
          </div>
          <h4 className="text-lg font-bold text-black uppercase">Data Privacy Guarantee</h4>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FaCheck} className="w-5 h-5 text-black mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-bold text-black uppercase">Case Use Only</p>
              <p className="text-xs text-gray-600">Your information is strictly used for The Dynamic Pay Claim investigation.</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FaLock} className="w-5 h-5 text-black mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-bold text-black uppercase">Encrypted Storage</p>
              <p className="text-xs text-gray-600">All data is encrypted and stored on secure, private servers.</p>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t-2 border-gray-200">
          <p className="text-xs text-gray-500">
            <span className="font-bold text-black">Questions?</span> Contact us at{' '}
            <span className="text-red-600 font-bold underline decoration-red-600">info@dynamicpay.org</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterPrivacyNote;